<template>
  <div :class="b()">
    <ga-product-card-vertical
      v-for="(slot, index) in displaySlots"
      v-show="slot.product || slot.skeleton"
      :key="slot.product?.itemId ?? `skeleton-${index}`"
      :class="slot.skeleton ? b('skeleton') : undefined"
      :product="slot.product"
      :skeleton-enable="slot.skeleton"
      v-bind="getProductCardProps(index)"
    />
  </div>
</template>

<script src="./product-list.scripts.js" />

<style module src="./product-list.styles.scss" lang="scss" />
